import React from 'react';
import styles from './Error404.module.css';

const Error404 = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
      
        <i className={styles.notFoundIcon}></i>
        
        <h1 className={styles.errorCode}>404</h1>
        <h2 className={styles.errorTitle}>Page Not Found</h2>
        
        <p className={styles.errorMessage}>
          We're sorry, the page you are looking for seems to have been moved, renamed, or does not exist. 
          Perhaps you're looking for a different suite?
        </p>
        
        <a href="/" className={styles.homeButton}>
          Return to Homepage
        </a>
      </div>
    </div>
  );
};

export default Error404;